import { KibanaFilterType } from '../filter-interfaces';
import KibanaFilterMetadata from './osd-filter-metadata';
export default class KibanaLookupFilterMetadata extends KibanaFilterMetadata {
    id;
    name;
    alertEventId;
    constructor(id, name, key, negate = false, alertEventId = null, indexPattern, alias = null, disabled = false) {
        super(key, `lookup: ${name}`, KibanaFilterType.Lookup, negate, indexPattern, alias, disabled);
        this.id = id;
        this.name = name;
        this.alertEventId = alertEventId;
    }
}
//# sourceMappingURL=osd-lookup-filter-metadata.js.map